import { useState, useMemo } from 'react';

/**
 * Hook to manage sorting state for server-side sorted TanStack tables.
 *
 * @param {Object[]} defaultSort - Initial sorting state, e.g. [{ id: 'updated_at', desc: true }]
 * @returns {{ sorting: Object[], onSortingChange: Function, sortByField: string|undefined }}
 */
export const useServerSideSorting = (defaultSort = []) => {
  const [sorting, setSorting] = useState(defaultSort);

  const sortByField = useMemo(() => {
    if (sorting.length !== 0) {
      const prefix = sorting[0].desc ? '-' : '';
      return `${prefix}${sorting[0].id}`;
    }
    return undefined;
  }, [sorting]);

  return { sorting, onSortingChange: setSorting, sortByField };
};
